import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    userDetails: [],
    getUserContent: [],
    getUserFaq: [],
    getUserHomepage: [],
    userHomepageRes: [],
    getSiteRes: [],
    userFaqinfo: [],
    userContentRes: [],
    getBannerRes: [],
    error: "",
}

const siteSettingSlice = createSlice({
    name: 'siteSettings',
    initialState,
    reducers: {
        getuserInfo: (state, action) => {
            state.userDetails = action.payload
        },
        userContent: (state, action) => {
            state.userContentRes = action.payload
        },
        userFaq: (state, action) => {
            state.userFaq = action.payload
        },
        userHomepage: (state, action) => {
            state.userHomepageRes = action.payload
        },
        siteInfo: (state, action) => {
            state.getSiteRes = action.payload
        },
        bannerInfo: (state, action) => {
            state.getBannerRes = action.payload
        }
    }
})

export const { getuserInfo, userContent, userFaq, siteInfo, bannerInfo, userHomepage } = siteSettingSlice.actions;
export default siteSettingSlice.reducer;


export const getUserDetails = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.GetData(`${frontUrl}/${API.GET_USER_DETAILS}`);
            callback(response);
            dispatch(getuserInfo(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

// DEMO

export const getUserContent = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_USER_CONTENT}`, data);
            callback(response);
            dispatch(userContent(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

// DEMO1
export const getUserFaq = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_USER_FAQ}`, data);
            callback(response);
            dispatch(userFaq(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };
// DEMO2
export const getUserHomepage = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API.GET_USER_HOMEPAGE_DETAILS}`, data);
            callback(response);
            dispatch(userHomepage(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };


export const getSiteInfo = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.GetData(`${frontUrl}/${API?.GET_SITE_SETTINGS}`);
            callback(response);
            dispatch(siteInfo(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const getBannerInfo = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.GetData(`${frontUrl}/${API?.GET_BANNERS}`);
            callback(response);
            dispatch(bannerInfo(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };








